import { Pagination, Resource, Statement } from "@/helpers/Interfaces";
import Pager from "@/helpers/Pager";
import axios from "axios";
import { merge } from "lodash";

export default class TasksTagsService
{
    /**
     * @param model FormModel
     *
     * @returns Promise<FormModel>
     */
    public static async create(model: FormModel): Promise<Resource<FormModel>>
    {
        return (await axios.post<Resource<FormModel>>(`admin/renters/taskTags `, model)).data;
    }

    /**
     * @param publicId string
     * @param model FormModel
     *
     * @returns Promise<FormModel>
     */
    public static async update(publicId: string, model: FormModel): Promise<Resource<FormModel>>
    {
        return (await axios.put<Resource<FormModel>>(`admin/renters/taskTags/${publicId}`, model)).data;
    }

    /**
     * @param publicId string
     *
     * @returns Promise<FormModel>
     */
    public static async fetch(publicId: string): Promise<Resource<FormModel>>
    {
        return (await axios.get<Resource<FormModel>>(`admin/renters/taskTags/${publicId}`)).data;
    }

    /**
     * @param publicId string
     *
     * @returns Promise<Statement>
     */
    public static async deleteItem(publicId: string): Promise<Statement>
    {
        return (await axios.delete(`admin/renters/taskTags/${publicId}`)).data as Statement;
    }


    /**
     * @param pager Pager
     *
     * @returns Promise<Pagination<Resource<ListItemModel>>
     */
    public static async getList(pager: Pager): Promise<Pagination<Resource<ListItemModel>>>
    {
        return (await axios.get<Pagination<Resource<ListItemModel>>>(`admin/renters/taskTags`, {
            params: merge({}, pager.data())
        })).data;
    }

    /**
     * @param search string
     * @param limit number
     *
     * @returns Promise<ListItemModel[]>
     */
    public static async getAutocompleteList(search: string, limit: number = 5): Promise<ListItemModel[]>
    {
        return (await axios.get<ListItemModel[]>('admin/renters/taskTags/autocomplete', {
            params: {
                search: search,
                limit: limit
            }
        })).data;
    }

    /**
     * @param publicId string
     *
     * @returns Promise<ListItemModel>
     */
    public static async fetchAutocompleteModelByPublicId(publicId: string): Promise<ListItemModel>
    {
        return (await axios.get<ListItemModel>(`admin/renters/taskTags/autocomplete/publicId/${publicId}`)).data;
    }

    /**
     * @param id number
     *
     * @returns Promise<ListItemModel>
     */
    public static async fetchAutocompleteModelById(id: number): Promise<ListItemModel>
    {
        return (await axios.get<ListItemModel>(`admin/renters/taskTags/autocomplete/id/${id}`)).data;
    }
}

export interface FormModel {
    name: string;
}

export interface ListItemModel extends FormModel {
    id: number;
    publicId: string;
    isDefault: boolean;
}

export enum TaskTagName {
    BOK = 'BOK',
    BO = 'BO',
    OW = 'OW'
}
